// extracted by mini-css-extract-plugin
export default {"AllNotifications_wrapper__":"AllNotification_AllNotifications_wrapper____OsxAr"};